import { makeid } from '../../../utils/formatStrings';
import { EVehicleTypes } from '../fabrication-contracts/types';
import { IPavementData } from '../fabrication-mockups/types';
import { IFabricationProject } from '../fabrication-projects/types';

// Action Types
export enum Types {
  UPDATE_FABRICATION_PURCHASE_ORDER_SETTINGS = 'fabricationPurchaseOrder/UPDATE_FABRICATION_PURCHASE_ORDER_SETTINGS',
  UPDATE_FABRICATION_STEP = 'fabricationPurchaseOrder/UPDATE_FABRICATION_STEP',

  FINISH_ORDER = 'fabricationPurchaseOrder/FINISH_ORDER',
  FINISH_ORDER_SUCCESS = 'fabricationPurchaseOrder/FINISH_ORDER_SUCCESS',
  FINISH_ORDER_FAILURE = 'fabricationPurchaseOrder/FINISH_ORDER_FAILURE',

  CLEAN_FABRICATION_PURCHASE_ORDER_SETTINGS = 'fabricationPurchaseOrder/CLEAN_FABRICATION_PURCHASE_ORDER_SETTINGS'
}

export enum EFabricationOrderSteps {
  CONSTRUCTION_IDENTIFICATION = 0,
  DETAILING_PROJECT = 1,
  EXTRA_ITENS = 2,
  CHECKOUT = 3
}

export interface IFabricationPurchaseOrderState {
  fabricationOrderStep: EFabricationOrderSteps;

  constructionIdentification: IConstructionIdentificationState;

  detailingProject: IDetailingProjectState;

  extraItens: IExtraItensState;

  finishOrderLoading: boolean;
  finishOrderError: boolean;

  createdOrderId?: number;
}

export interface IConstructionIdentificationState {
  comingFromBuyAgain?: boolean;

  contractNumber?: string;
  customerShipToId?: string;

  gerdauOrderNumber?: number;
  gerdauRevisionNumber?: number;

  location?: string;

  orderNumber: string;
  desiredDate?: string;
  towers: string[];
  isSingleTower: boolean;

  cep: string;
  address: string;
  state: string;
  city: string;
  observation: string;
}

// DETALHAMENTO PROJETO
export interface IDetailingProjectState {
  itens: IFabricationProjectItem[];
  observation: string;
  productType: EProductType;
  vehiclesTypes?: EVehicleTypes[];
}

export enum EProductType {
  CORTE_E_DOBRA = 'Corte e Dobra',
  VERGALHAO_CORTADO_DOBRADO = 'Vergalhão cortado e dobrado',
  ESTACA_ARMADA = 'Estaca armada'
}

export interface IFabricationProjectItem {
  key: string;
  projectId?: number;
  pavement: string;
  pavements: IPavementData[];
  revision: string;
  amount?: number;
  completeDrawing: boolean;
  observation: string;
  projectSelected?: IFabricationProject;
}

export const getDefaultFabricationProjectItem =
  (): IFabricationProjectItem => ({
    key: makeid(6),
    projectId: undefined,
    pavement: '',
    pavements: [],
    revision: '',
    amount: 1,
    completeDrawing: true,
    observation: ''
  });

// ITENS EXTRAS  (faltando TIPO DE AÇO)

export interface IExtraItensState {
  annealedWires: IAnnealedWire[];
  otherPieces: IFabricationOrderExtraItem[];
}

// ARAMES

export enum EProvideWireQuantityTypes {
  PERCENTAGE = 'PERCENTAGE',
  WEIGHT = 'WEIGHT'
}

export interface IAnnealedWire {
  annealedWireTypeId?: string;
  key?: number;
  provideQuantityBy?: EProvideWireQuantityTypes;

  weight?: number | string;
  percentage?: number | string;
}

export const DEFAULT_WIRE_ITEM: IAnnealedWire = {
  annealedWireTypeId: undefined,
  provideQuantityBy: EProvideWireQuantityTypes.WEIGHT,
  percentage: '',
  weight: ''
};

//
export interface IFabricationOrderExtraItem {
  pieceTypeId?: number;
  diameterId?: number;
  measureA?: number;
  measureB?: number;
  measureC?: number;
  amount?: number;
  weight?: number | string;

  steelTypeId?: number;
  key?: number;
}

export const DEFAULT_EXTRA_ITEM: IFabricationOrderExtraItem = {
  pieceTypeId: undefined,
  steelTypeId: undefined,
  diameterId: undefined,
  amount: undefined,
  measureA: undefined,
  measureB: undefined,
  measureC: undefined,
  weight: ''
};
